import React from 'react'
import { ComponentConfig } from '@puckeditor/core'
import type { ThemeCustomFields } from 'breaktime-theme/src/puck/theme-config'
import {
  getPuckFileUrl,
  UploadedFile,
} from 'breaktime-theme/src/puck/fields/FileUploadField'
import ReactCompareImage from 'steps/shared/ReactCompareImage'

export type ListicleImageComparisonProps = {
  leftImage: UploadedFile | string
  rightImage: UploadedFile | string
}

export const PuckListicleImageComparison: ComponentConfig<{
  props: ListicleImageComparisonProps
  fields: ThemeCustomFields
}> = {
  label: 'Listicle Image Comparison',
  defaultProps: {
    leftImage: '',
    rightImage: '',
  },
  fields: {
    leftImage: { type: 'fileUpload', label: 'Left / Before Image' },
    rightImage: { type: 'fileUpload', label: 'Right / After Image' },
  },
  render: ({ leftImage, rightImage }) => {
    const leftUrl = leftImage ? getPuckFileUrl(leftImage) : ''
    const rightUrl = rightImage ? getPuckFileUrl(rightImage) : ''
    if (!leftUrl || !rightUrl) {
      return (
        <div className="content-item image-compare">
          <em>Select a left and right image to compare.</em>
        </div>
      )
    }
    return (
      <div className="content-item image-compare">
        <ReactCompareImage leftImage={leftUrl} rightImage={rightUrl} />
      </div>
    )
  },
}
